import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { getAdelBrandsURL, getDefaultValuesURL, getInvoicesURL } from '../api';
import moment from 'jalali-moment'
import  ToTitleCase from '../helpers/mmg'
// initial state
export const initialState = {
  Loading: false,
  FiscalYearId : '',
  FiscalYearStartDate : '',
  FiscalYearEndDate : '',
  CashTitle : "",
  CashId : 0,
  StockTitle : "",
  StockId : 0,
  BankAccountTitle : "",
  BankAccountId : 0,
  CashUserFullName : "",
  CashUserId : 0,
  DeliverylocationTitle: "",
  DeliverylocationId : 0,
  CurrencyTitle : "",
  CurrencyId : 0,
  SaleTypeTitle : "",
  SaleTypeId : 0,
  PosTitle : "",
  PosId: 0,
  CustomerId : 0,
  CustomerName : "",
  CustomerLastName : "",
  CustomerDLCode :  "",
  CustomerDLTitle : "",
  CustomerFullName : "",
  CustomerMainAddress : "",
  CustomerMainPhone : "",
  CustomerGroup : "",
  CustomerRemainAmount : 0,
  CustomerSaleAndFinancialDataModel : {}
};

// our slice
const defaultValuesSlice = createSlice({
  name: "defaultValues",
  initialState,
  reducers: {
    setItems: (state, { payload }) => {

      console.log("setITEMS DEFAULT VALUES");
      console.log(payload);
      state.Loading = false;
      state.CashTitle = payload.CashTitle;
      state.CashId = payload.CashId;
      state.StockTitle = payload.StockTitle;
      state.StockId = payload.StockId;
      state.BankAccountTitle = payload.BankAccountTitle;
      state.BankAccountId = payload.BankAccountId;
      state.CashUserFullName = payload.CashUserFullName;
      state.CashUserId = payload.CashUserId;
      state.DeliverylocationTitle= payload.DeliverylocationTitle;
      state.DeliverylocationId = payload.DeliverylocationId;
      state.CurrencyTitle = payload.CurrencyTitle;
      state.CurrencyId = payload.CurrencyId;
      state.SaleTypeTitle = payload.SaleTypeTitle;
      state.SaleTypeId = payload.SaleTypeId; 
      state.PosId = payload.PosId;
      state.PosTitle = payload.PosTitle;
      state.CustomerId = payload.CustomerId;
      state.CustomerName = payload.CustomerName;
      state.CustomerLastName = payload.CustomerLastName;
      state.CustomerDLCode =  payload.CustomerDLCode;
      state.CustomerDLTitle =  payload.CustomerDLTitle;
      state.CustomerFullName = payload.CustomerFullName;
      state.CustomerMainAddress = payload.CustomerMainAddress;
      state.CustomerMainPhone =  payload.CustomerMainPhone;
      state.CustomerGroup = payload.CustomerGroup;
      state.CustomerRemainAmount = payload.CustomerRemainAmount;
      state.PartyType = payload.PartyType;
      state.EconomicCode = payload.EconomicCode;
      state.IdentificationCode = payload.IdentificationCode;
      state.RegistrationCode = payload.RegistrationCode;
      state.PostalCode = payload.PostalCode;
      state.CustomerInCashCheques = payload.CustomerInCashCheques;
      state.CustomerReturnedCheques = payload.CustomerReturnedCheques;
      state.FiscalYearId = payload.FiscalYearId;
      state.FiscalYearStartDate = payload.FiscalYearStartDate;
      state.FiscalYearEndDate = payload.FiscalYearEndDate;
      state.CustomerSaleAndFinancialDataModel = payload.CustomerSaleAndFinancialDataModel;
      state.PortalUsers = payload.PortalUsers;
    },
    setError: (state) => {
      state.error = true;
    },
    setLoading: (state) => {
      state.Loading = true;
    },
    setLoadingFalse: (state) => {
      state.Loading = false;
    },
    clearData: (state) => {
      state.Loading = false;
      state.CashTitle = '';
      state.CashId = '';
      state.StockTitle = '';
      state.StockId = '';
      state.BankAccountTitle = '';
      state.BankAccountId = '';
      state.CashUserFullName = '';
      state.CashUserId = '';
      state.DeliverylocationTitle= '';
      state.DeliverylocationId = '';
      state.CurrencyTitle = '';
      state.CurrencyId = '';
      state.SaleTypeTitle = '';
      state.SaleTypeId ='';
      state.PosId ='';
      state.PosTitle ='';
      state.CustomerId = '';
      state.CustomerName = '';
      state.CustomerLastName = '';
      state.CustomerDLCode =  '';
      state.CustomerDLTitle = '';
      state.CustomerFullName = '';
      state.CustomerMainAddress = '';
      state.CustomerMainPhone =  '';
      state.CustomerGroup = '';
      state.CustomerRemainAmount ='';
      state.PartyType = '';
      state.EconomicCode = '';
      state.IdentificationCode ='';
      state.RegistrationCode ='';
      state.PostalCode = '';
      state.CustomerInCashCheques = '';
      state.CustomerReturnedCheques = '';
      state.FiscalYearId ='';
      state.FiscalYearStartDate = '';
      state.FiscalYearEndDate = '';
      state.CustomerSaleAndFinancialDataModel = {};
      state.PortalUsers = [];
      state.error = false;
    }
  },
});

// export the actions
export const { setItems, setError, clearData, setLoading , setLoadingFalse} = defaultValuesSlice.actions;

// export the selector (".items" being same as in slices/index.js's "items: something")
export const itemsSelector = (state) => state.items;

// export the default reducer
export default defaultValuesSlice.reducer;


// fetch all items
export function fetchDefaultValues(input) {
  return async (dispatch) => {
  
    console.log("getting fetchDefaultValues");
    console.log(input);
    dispatch(setLoading());
   await axios.post(getDefaultValuesURL()+'?username='+input.authUser.username + '&password='+encodeURIComponent(input.authUser.password)+'&token='+input.authUser.token)
   .then(response => {

            const result = response.data;    
            console.log(result);
            localStorage.removeItem("parameter");
            localStorage.setItem('defaultValue', JSON.stringify(response.data));
            dispatch(setItems(response.data));
            

      }).catch(function (err) {
        console.log("error in Fetching Default Values");
        console.log(err);
        dispatch(setError());
      }).finally(()=> {
        dispatch(setLoadingFalse());
      });


  }
  };

export function clearDfaultValues() {
  return async (dispatch) => {


      dispatch(clearData());
   
  };
}